module.exports = __webpack_public_path__ + "img/DE01494.54d9a4f2.png";